const checkTWPhoneFormat = (phoneInput) => {
    // Regular expression to allow only opening with 09 
    const regex = /^09\d{8}$/;
    return regex.test(phoneInput);
  };

export default checkTWPhoneFormat;
  